import { inject, injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { SpecialSettingsStore } from '../../common/stores/special-settings.store';

const portalStartDateSettingsKey = 'portal-start-date-settings';

export interface PortalStartDateSettings {
    enabled: boolean;
    startDate: string;
}

@injectable()
export class PortalStartDateSettingsStore {
    @observable portalStartDateSettings: PortalStartDateSettings | undefined = undefined;
    @observable loaded = false;

    constructor(
        @inject(SpecialSettingsStore) private readonly specialSettings: SpecialSettingsStore
    ) {
        makeObservable(this);
        this.loadPortalStartDateSettings();
    }

    @action
    loadPortalStartDateSettings = async () => {
        const settings = await this.specialSettings.getAsync<PortalStartDateSettings>(
            portalStartDateSettingsKey
        );
        runInAction(() => {
            this.portalStartDateSettings = settings;
            this.loaded = true;
        });
    };
}
